import { Paper, Grid, Typography } from '@mui/material';
import { Close } from '@mui/icons-material';
import styled from '@emotion/styled';
import { theme } from 'config';

export const Container = styled(Paper)({
  padding: '20px',
  borderRadius: '4px',
  maxWidth: '900px',
  width: '100%',
  overflow: 'auto',
  maxHeight: 'calc(100vh - 40px)',
  height: 'fit-content',
});

export const IconWrapper = styled(Grid)({
  cursor: 'pointer',
  width: 'fit-content',
  marginLeft: 'auto',
  WebkitTapHighlightColor: 'transparent',
});

export const CloseIcon = styled(Close)({
  color: theme.palette.primary.main,
  cursor: 'pointer',
});

export const ContentWrapper = styled(Grid)({
  padding: '40px',
  display: 'flex',
  flexDirection: 'column',

  [theme.breakpoints.down('sm')]: {
    padding: '10px 0',
  },
});

export const Notice = styled(Grid)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  marginTop: '20px',
});

export const FlightDescription = styled(Typography)({
  color: '#A2A2A1',
  fontSize: '12px',
});
